import {ValBarreNavigationItem} from "../../../../../val-ammon-composants/val-composants-lib/src/public-api";
import {APrHabilitation} from "../../../../../val-ammon-permissions/val-permissions-lib/src/public-api";

//Représente les items de navigation
export const navigationItems: ValBarreNavigationItem[] =
[
  {dico: "EB67CC07-5171-4B43-9A82-8FF9F3A8916A", iconeClass: "fas fa-home", navigationCommande: ["/main", {outlets: {page: ['accueil']}}]},
  {dico: "B298F57C-A1B1-4CB8-999C-08605BA28CEE", iconeClass: "fas fa-file-invoice", navigationCommande: ["/main", {outlets: {page: ['recherche-facture-achat']}}]},
  {dico: "AA0ED08D-12A2-4BD9-B3B0-C591D9B2659F", iconeClass: "fas fa-file-invoice", navigationCommande: ["/main", {outlets: {page: ['recherche-facture-vente']}}]},
];

//Gère la création des items de la barre de navigation
export class CreerBarreNavigationItems 
{
  //Création
  //  Paramètres
  //    habilitation : Données d’habilitation
  constructor (habilitations: APrHabilitation[]) 
  {
    this.habilitations = habilitations;
    this.navigationItems = [];
  }

  //Crée les items de la barre de navigation
  //  Retourne
  //    Les items de la barre de navigation
  public Executer () : ValBarreNavigationItem[] 
  {
    for (const navigationItem of navigationItems)
    {
      this.AjouterNavigationItem (navigationItem, null);
    }

    return this.navigationItems;
  }

  //Ajoute un item
  //  Paramètres
  //    navigationItem       : Données de l’item
  //    navigationItemParent : Données de l’item parent
  private AjouterNavigationItem (navigationItem: ValBarreNavigationItem, navigationItemParent: ValBarreNavigationItem | null) : void 
  {
    let habilitation: APrHabilitation | undefined;
    let navigationItemEnCours: ValBarreNavigationItem | null;

    if (navigationItem.dico)
    {
      habilitation = this.habilitations.find ((hab) => hab.identifiantDico.toUpperCase () === navigationItem.dico!.toUpperCase ());

      if (habilitation && habilitation.modification)
        navigationItemEnCours = this.CreerNavigationItem (navigationItem, habilitation.libelle);
      else
        navigationItemEnCours = null;
    }
    else
      navigationItemEnCours = this.CreerNavigationItem (navigationItem, navigationItem.libelle);

    if (navigationItemEnCours)
    {
      if (navigationItemParent)
        navigationItemParent.commandes!.push (navigationItemEnCours);
      else
        this.navigationItems.push (navigationItemEnCours);

      if (navigationItem.commandes && navigationItem.commandes.length > 0)
      {
        for (const navigationItemCommande of navigationItem.commandes)
          this.AjouterNavigationItem (navigationItemCommande, navigationItemEnCours);
      }
    }
  }

  //Crée un item
  //  Paramètres
  //    navigationItem : Données de l’item
  //    libelle        : Libellé
  private CreerNavigationItem (navigationItem: ValBarreNavigationItem, libelle: string | undefined) : ValBarreNavigationItem 
  {
    let navigationItemEnCours: ValBarreNavigationItem;

    navigationItemEnCours = new ValBarreNavigationItem ();
    navigationItemEnCours.dico = navigationItem.dico;
    navigationItemEnCours.iconeClass = navigationItem.iconeClass;
    navigationItemEnCours.libelle = libelle;
    navigationItemEnCours.navigationCommande = navigationItem.navigationCommande;

    return navigationItemEnCours;
  }

  private habilitations:   APrHabilitation[];
  private navigationItems: ValBarreNavigationItem[];
}